import AdoptableSlider from './AdoptableSlider';
import AdoptableSliderContainer from './AdoptableSlider.container';

export default AdoptableSliderContainer(AdoptableSlider);
